<template>
  <b-card id="announcement-detail">
    <h3>Pengumuman</h3>
    <p><span v-if="isEdit">Edit</span><span v-else>Tambah</span> pengumuman</p>
    <b-form-group
      v-for="form in fields"
      :key="form.label"
      :id="form.id"
      :label="form.label"
      :label-for="`${form.label}-${form.id}`"
    >
      <mavon-editor
        v-if="form.label === 'description'"
        id="markdown-editor"
        language="en"
        :config="editorConfig"
        v-model="form.value"
      />

      <b-form-textarea
        v-else-if="
          form.label !== 'image' &&
          form.label !== 'event_start_at' &&
          form.label !== 'event_end_at' &&
          form.label !== 'icon'
        "
        :id="`${form.label}-${form.id}`"
        v-model="form.value"
        required
      ></b-form-textarea>

      <b-form-datepicker
        v-else-if="
          form.label == 'event_start_at' || form.label == 'event_end_at'
        "
        :min="new Date()"
        :id="`${form.label}-${form.id}`"
        v-model="form.value"
      ></b-form-datepicker>

      <div v-else-if="form.label == 'image' || form.label == 'icon'">
        <div class="container">
          <img
            class="img-fluid"
            :src="typeof form.value == 'string' ? form.value : imagePath"
            :alt="typeof form.value == 'string' ? form.value : imagePath"
          />
        </div>
        <b-form-file
          v-model="form.value"
          class="mt-3"
          @change="handleChangeFile"
        ></b-form-file>
      </div>
    </b-form-group>
    <b-card-footer>
      <b-button
        class="btn-primary"
        @click="isEdit ? handleSaveEdit() : handleSaveAdd()"
        >Save</b-button
      >
    </b-card-footer>
  </b-card>
</template>

<script>
import axios from "axios";
import config from "../../../config";
import DatePicker from "vue2-datepicker";

export default {
  name: "AnnouncementDetail",
  components: { DatePicker },
  data() {
    return {
      data: null,
      fields: [],
      forms: [
        "no",
        "title",
        "description",
        "image",
        "author",
        "event_start_at",
        "event_end_at",
      ],
      imagePath: null,
      editorConfig: {
        image: false, // Menonaktifkan fungsi unggah gambar
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id;
    },
  },
  async mounted() {
    if (this.isEdit) {
      await this.getData();
    }
    this.initForm();
  },
  methods: {
    initForm() {
      this.fields = this.forms.reduce((acc, f, idx) => {
        if (f == "no" || f == "aksi" || f == "created_at" || f == "updated_at")
          return [...acc];

        if (f == "image")
          return [
            ...acc,
            {
              id: `${f}-${idx}`,
              label: f,
              value: this.isEdit
                ? config.webprofileApiUrl +
                  "/company-profile/" +
                  this.data["imageUrl"]
                : [],
            },
          ];

        return [
          ...acc,
          {
            id: `${f}-${idx}`,
            label: f,
            value: this.isEdit ? this.data[f] : "",
          },
        ];
      }, []);
    },
    async getData() {
      const res = await axios.get(
        config.webprofileApiUrl +
          `/company-profile/announcement/${this.$route.params.id}`
      );

      if (res.data) {
        this.data = res.data;
      }
    },
    async handleSaveEdit() {
      const id = this.data.id;

      try {
        let bodyFormData = new FormData();

        bodyFormData.append("title", this.fields[0].value);
        bodyFormData.append("description", this.fields[1].value);
        bodyFormData.append("image", this.fields[2].value);
        bodyFormData.append("author", this.fields[3].value);
        bodyFormData.append(
          "event_start_at",
          new Date(this.fields[4].value).toISOString()
        );
        bodyFormData.append(
          "event_end_at",
          new Date(this.fields[5].value).toISOString()
        );

        await axios({
          method: "patch",
          url: config.webprofileApiUrl + `/company-profile/announcement/${id}`,
          data: bodyFormData,
          headers: { "Content-Type": "multipart/form-data" },
        });

        this.$toasted.success("Berhasil Disimpan");
      } catch (err) {
        this.$toasted.error("Gagal Disimpan");
      } finally {
        this.getData();
      }
    },
    async handleSaveAdd() {
      try {
        let bodyFormData = new FormData();

        bodyFormData.append("title", this.fields[0].value);
        bodyFormData.append("description", this.fields[1].value);
        bodyFormData.append("image", this.fields[2].value);
        bodyFormData.append("author", this.fields[3].value);
        bodyFormData.append(
          "event_start_at",
          new Date(this.fields[4].value).toISOString()
        );
        bodyFormData.append(
          "event_end_at",
          new Date(this.fields[5].value).toISOString()
        );

        await axios({
          method: "post",
          url: config.webprofileApiUrl + "/company-profile/announcement",
          data: bodyFormData,
          headers: { "Content-Type": "multipart/form-data" },
        });

        this.$toasted.success("Berhasil Ditambahkan");

        this.$router.push(`/app/web/announcement`);
      } catch (err) {
        this.$toasted.error("Gagal Ditambahkan");
      }
    },
    resetModal() {
      this.fields = null;
      this.imagePath = null;
    },
    handleClick() {
      this.$emit("click-ok", this.fields);
    },
    handleChangeFile(e) {
      const url = URL.createObjectURL(e.target.files[0]);

      this.imagePath = url;
    },
  },
};
</script>

<style>
#announcement-detail .markdown-body {
  z-index: 104;
}

#announcement-detail .b-calendar .b-calendar-grid {
  padding: 2rem;
}
</style>
